export let DEVELOPMENT = 2;
export let BASE_URL_IMG = "http://localhost:8082/images/flexihours/";
let hostIP = "api.flexihours.co.za/";
if (DEVELOPMENT === 2) {
  hostIP = "api.flexihours.es/";
  BASE_URL_IMG = "https://img.flexihours.es/";
} else if (DEVELOPMENT === 1) {
  hostIP = "api.flexihours.co.za/";
  BASE_URL_IMG = "https://img.flexihours.co.za/";
} else if (DEVELOPMENT === 3) {
  hostIP = "api.flexihours.us/";
  BASE_URL_IMG = "https://img.flexihours.us/";
} else if (DEVELOPMENT === 4) {
  hostIP = "api.flexihours.com.au/";
  BASE_URL_IMG = "https://img.flexihours.com.au/";
}
let protocol = "https://";

export let BASE_URL = protocol + hostIP;
